import Editor from "@monaco-editor/react";
import { Box, Typography } from "@mui/material";
import { observer } from "mobx-react-lite";
import { useTranslation } from "react-i18next";
import { Language } from "../../../../../../components/common/ApiReferenceDialog/LanguagesDropdown/LanguagesDropdown";
import { ThemeMode } from "../../../../../../constants/themes";
import { useTheme } from "../../../../../../context/ThemeContext";
import styles from "./PayloadCodeEditor.module.scss";

type PayloadCodeEditorProps = {
	code: string | null | undefined;
	language: Language | "json";
};

const PayloadCodeEditor = ({ code, language }: PayloadCodeEditorProps) => {
	const { t } = useTranslation("video_editing", { keyPrefix: "lab.apiPayloadPreview" });
	const { mode } = useTheme();
	const getEditorLanguage = (): string => {
		if (language === "nodejs") return "javascript";
		if (language === "csharp") return "csharp";
		if (language === "curl") return "shell";
		if (language === "json") return "json";
		return language;
	};

	if (code !== null && code !== undefined) {
		return (
			<Box className={styles.payloadCodeEditorContainer}>
				<Box className={styles.editorContainer}>
					<Editor
						height="100%"
						defaultLanguage={getEditorLanguage()}
						language={getEditorLanguage()}
						theme={mode === ThemeMode.Dark || mode === ("labs" as ThemeMode) ? "vs-dark" : "light"}
						value={code}
						options={{
							lineNumbers: "on",
							minimap: { enabled: false },
							wordWrap: "off",
							tabSize: 4,
							fontSize: 14,
							readOnly: true,
						}}
					/>
				</Box>
			</Box>
		);
	}

	return (
		<div className={styles.emptyState}>
			<Typography className={styles.title} variant="h6">
				{t("emptyState.title")}
			</Typography>
			<Typography className={styles.description} variant="body1">
				{t("emptyState.description")}
			</Typography>
		</div>
	);
};

export default observer(PayloadCodeEditor);
